/*!
    * @product/scmp-sdk 1.1.36
    * built by undefined
  */
function n(){if(!(typeof window>"u"))return window}export{n as a};
//# sourceMappingURL=chunk-NF2M4U24.js.map
